module.exports = __webpack_public_path__ + "static/media/thumbnail-twinspot.61a4658d.png";